import { FC } from 'react';
import StudentAllocation from './StudentAllocation';
import UseStudentAllocation from './UseStudentAllocation';

const StudentAllocationContainer: FC = () => {
  return <StudentAllocation {...UseStudentAllocation()} />;
};

export default StudentAllocationContainer;
